export default {
  list: [],
  currentProfile: null,
  filteredList: [],
  keywords: {},
  services: [],
  testimonials: [],
  salesEnquiries: [],
  salesEnquiryCurrentProfile: {},
};
